import { Control, Controller, FieldErrors } from 'react-hook-form'
import { FormSelect } from '../../../components/forms/select/FormSelect'
import { useRecuperarOpcCatalogoQuery } from '../../../redux/api'
import { AppCodigosCatalogo } from '../../../utils/Constantes'
import { Opcion } from '../../../models/catalogo.type'
import useHasPermiso from '../../../hooks/autenticacion/useHasPermiso'
import { Roles } from '../../../utils/Roles'
import { Tarea } from '../models'

type Props = {
  control: Control<any>
  errors: FieldErrors | null
  isModoEditar: boolean
  tareaId?: Tarea
  filtro: boolean
}

const OPCIONES_BLOQUEADAS = 'BAJA'

export const InputEstatus = ({ control, errors, isModoEditar, tareaId, filtro }: Props) => {
  const { data: catEstatus } = useRecuperarOpcCatalogoQuery(AppCodigosCatalogo.TAREAS_ESTATUS)
  const { hasPermiso } = useHasPermiso()
  const usuarioPermiso = hasPermiso([Roles.roleTareasCrear])

  return (
    <>
      <Controller
        control={control}
        name='estatus'
        render={({ field: { onChange, value } }) => (
          <FormSelect
            nombre='Estatus'
            nombreCampo='estatus'
            value={value}
            isObligatorio={true}
            errors={errors}
            elementos={
              // Reglas de transición de estatus en UI:
              // - Nueva tarea: sólo permite iniciar en EN_PROCESO.
              // - Edición: se restringen opciones según estatus actual (ej. no mostrar VENCIDA).
              // No identificado en el codigo/configuracion revisada: si el backend impone las
              // mismas reglas o si son sólo para UX.
              !isModoEditar
                ? catEstatus?.filter((e: Opcion) => e.valor === 'EN_PROCESO')
                : tareaId?.estatus === 'COMPLETADA' || tareaId?.estatus === 'EN_PROCESO'
                ? catEstatus?.filter((e: Opcion) => e.valor !== 'VENCIDA')
                : tareaId?.estatus === 'VENCIDA'
                ? catEstatus?.filter((e: Opcion) => e.valor !== 'EN_PROCESO')
                : catEstatus
            }
            onChange={(e: Event) => {
              onChange(e)
            }}
            placeholder='Ej. Completada'
            isDisabled={tareaId?.estatus === OPCIONES_BLOQUEADAS || !usuarioPermiso}
          />
        )}
      />
    </>
  )
}
